export class DateServiceI {
}
//# sourceMappingURL=date.service.js.map